/**
 * Common Indian GST HSN / SAC Codes Pre-loaded for Hamara Bill Book
 * Pure Code & Description definitions without forced tax rates.
 */

export const DEFAULT_COMMON_HSN_CODES = [
  // ==========================================
  // ⚡ ELECTRICAL & HOME APPLIANCES (Consumer Electronics)
  // ==========================================
  { 
    code: '8528', 
    label: 'TV (Television, LED TV, Smart TV, Monitors & Projectors)', 
    category: 'Electricals', 
    keywords: 'tv television smart led lcd screen monitor display oled' 
  },
  { 
    code: '8415', 
    label: 'AC (Air Conditioners, Split AC, Window AC & Inverter AC)', 
    category: 'Electricals', 
    keywords: 'ac air conditioner split window inverter cooling hvac' 
  },
  { 
    code: '8479', 
    label: 'Air Cooler (Desert Cooler, Personal Room Cooler & Evaporative Coolers)', 
    category: 'Electricals', 
    keywords: 'cooler air cooler desert cooler room cooler cooling fan water' 
  },
  { 
    code: '8418', 
    label: 'Refrigerator (Single/Double Door Fridge, Deep Freezers & Coolers)', 
    category: 'Electricals', 
    keywords: 'refrigerator fridge deep freezer cooling frost free' 
  },
  { 
    code: '8450', 
    label: 'Washing Machine (Front Load, Top Load, Semi-Automatic & Fully Automatic)', 
    category: 'Electricals', 
    keywords: 'washing machine washer laundry dryer automatic' 
  },
  { 
    code: '8414', 
    label: 'Electric Fans (Ceiling Fan, Table Fan, Pedestal Fan & Exhaust Fan)', 
    category: 'Electricals', 
    keywords: 'fan ceiling table pedestal exhaust bldc ventilator' 
  },
  { 
    code: '8516', 
    label: 'Geyser, Water Heater, Electric Iron, Microwave Oven & Toaster', 
    category: 'Electricals', 
    keywords: 'geyser water heater iron microwave oven toaster immersion rod heating' 
  },
  { 
    code: '8509', 
    label: 'Mixer Grinder, Juicer, Blender & Food Processor', 
    category: 'Electricals', 
    keywords: 'mixer grinder juicer blender mixie food processor chopper' 
  },
  { 
    code: '8539', 
    label: 'LED Bulbs, Tube Lights, Panel Lights, Lamps & Fixtures', 
    category: 'Electricals', 
    keywords: 'led bulb light tubelight lamp lighting panel chandelier' 
  },
  { 
    code: '8544', 
    label: 'Electrical Wires, Cables & Insulated Conductors', 
    category: 'Electricals', 
    keywords: 'wire cable wiring copper aluminum wire cord flexible' 
  },
  { 
    code: '8536', 
    label: 'Electrical Switches, Sockets, Plugs, MCB & Fuse', 
    category: 'Electricals', 
    keywords: 'switch socket plug mcb circuit breaker fuse modular board' 
  },
  { 
    code: '8504', 
    label: 'Inverter, UPS, Voltage Stabilizer, Transformer & Battery Charger', 
    category: 'Electricals', 
    keywords: 'inverter ups stabilizer voltage transformer charger adapter' 
  },
  { 
    code: '8507', 
    label: 'Inverter Batteries (Lead-Acid, Tubular & Lithium-Ion Batteries)', 
    category: 'Electricals', 
    keywords: 'battery inverter battery tubular lead acid solar lithium cell' 
  },
  { 
    code: '8421', 
    label: 'Water Purifier (RO, UV, UF Water Filters & Cartridges)', 
    category: 'Electricals', 
    keywords: 'water purifier ro filter uv aqua filtration cartridge' 
  },
  { 
    code: '8517', 
    label: 'Mobile Phones, Smartphones, Chargers & Networking Equipment', 
    category: 'Electronics', 
    keywords: 'mobile phone smartphone cell iphone android charger router modem' 
  },
  { 
    code: '8471', 
    label: 'Computers, Laptops, Hard Drives, Printers & IT Hardware', 
    category: 'Electronics', 
    keywords: 'computer laptop pc printer hard drive ssd keyboard mouse desktop' 
  },
  { 
    code: '8518', 
    label: 'Speakers, Soundbars, Headphones, Earphones & Microphones', 
    category: 'Electronics', 
    keywords: 'speaker soundbar bluetooth headphone earphone mic amplifier audio' 
  },
  { 
    code: '8525', 
    label: 'CCTV Cameras, Surveillance Systems & DVR/NVR', 
    category: 'Electronics', 
    keywords: 'cctv camera security surveillance dvr nvr ip camera' 
  },

  // ==========================================
  // 🌾 GROCERY & FMCG (Daily Essentials)
  // ==========================================
  { 
    code: '1006', 
    label: 'Rice (Basmati, Non-Basmati, Kolam, Sona Masoori & Paddy)', 
    category: 'Grocery', 
    keywords: 'rice basmati chawal paddy grain parboiled kolam sona masoori' 
  },
  { 
    code: '1101', 
    label: 'Wheat Flour (Atta, Maida, Sooji / Rawa)', 
    category: 'Grocery', 
    keywords: 'atta flour wheat maida sooji rawa semolina chakki' 
  },
  { 
    code: '1001', 
    label: 'Wheat & Meslin Grains (Gehun)', 
    category: 'Grocery', 
    keywords: 'wheat gehun grain whole cereal' 
  },
  { 
    code: '0713', 
    label: 'Pulses & Lentils (Dal - Toor, Moong, Chana, Urad, Masoor, Rajma, Chhole)', 
    category: 'Grocery', 
    keywords: 'dal pulses lentils toor arhar moong chana urad masoor rajma chhole besan' 
  },
  { 
    code: '1512', 
    label: 'Edible Cooking Oils (Mustard, Sunflower, Soyabean, Groundnut Oil)', 
    category: 'Grocery', 
    keywords: 'oil cooking edible oil mustard sunflower soyabean groundnut tel refined' 
  },
  { 
    code: '0405', 
    label: 'Pure Desi Ghee, Butter & Dairy Spreads', 
    category: 'Grocery', 
    keywords: 'ghee desi ghee butter makhan dairy cow buffalo' 
  },
  { 
    code: '0401', 
    label: 'Fresh Milk & Cream', 
    category: 'Grocery', 
    keywords: 'milk fresh doodh cream dairy cow buffalo pouch' 
  },
  { 
    code: '0402', 
    label: 'Milk Powder, Condensed Milk & Dairy Whitener', 
    category: 'Grocery', 
    keywords: 'milk powder dairy whitener condensed milk amulya' 
  },
  { 
    code: '0406', 
    label: 'Paneer, Cheese & Dairy Products', 
    category: 'Grocery', 
    keywords: 'paneer cheese cottage cheese dairy' 
  },
  { 
    code: '1701', 
    label: 'Sugar, Cane Sugar, Bura & Jaggery (Gur)', 
    category: 'Grocery', 
    keywords: 'sugar chini shakkar jaggery gur bura sweet' 
  },
  { 
    code: '0902', 
    label: 'Tea (Black Tea, CTC Chai Patti, Green Tea & Herbal Tea)', 
    category: 'Grocery', 
    keywords: 'tea chai chai patti green tea ctc leaf packet' 
  },
  { 
    code: '0901', 
    label: 'Coffee (Instant Coffee, Roasted Coffee Beans & Filter Coffee)', 
    category: 'Grocery', 
    keywords: 'coffee nescafe bru instant filter roasted beans' 
  },
  { 
    code: '0910', 
    label: 'Spices (Turmeric/Haldi, Chilli, Coriander, Jeera, Garam Masala)', 
    category: 'Grocery', 
    keywords: 'spices masala haldi turmeric chilli mirch coriander dhaniya jeera cumin garam masala' 
  },
  { 
    code: '2501', 
    label: 'Salt (Common Iodized Table Salt, Rock Salt / Sendha Namak)', 
    category: 'Grocery', 
    keywords: 'salt namak iodized rock salt sendha tata' 
  },
  { 
    code: '1905', 
    label: 'Biscuits, Cookies, Bread, Rusk & Bakery Items', 
    category: 'Grocery', 
    keywords: 'biscuit cookie bread rusk toast bakery cake pastry parle britannia' 
  },
  { 
    code: '1902', 
    label: 'Noodles, Pasta, Macaroni & Vermicelli (Sewai)', 
    category: 'Grocery', 
    keywords: 'noodle noodles maggi pasta macaroni sewai vermicelli spaghetti instant' 
  },
  { 
    code: '2106', 
    label: 'Namkeen, Bhujia, Chips, Packaged Snacks & Savories', 
    category: 'Grocery', 
    keywords: 'namkeen bhujia chips lays kurkure snack haldiram farsan mixture' 
  },
  { 
    code: '2103', 
    label: 'Sauces, Tomato Ketchup, Pickles (Achar), Mayonnaise & Chutney', 
    category: 'Grocery', 
    keywords: 'sauce ketchup tomato achar pickle chutney mayonnaise dip' 
  },
  { 
    code: '0801', 
    label: 'Dry Fruits & Nuts (Almonds/Badam, Cashews/Kaju, Raisins/Kishmish, Walnuts)', 
    category: 'Grocery', 
    keywords: 'dry fruits badam kaju almond cashew kishmish raisin walnut akhrot pista' 
  },
  { 
    code: '3401', 
    label: 'Bathing Soaps, Handwash & Toilet Soaps', 
    category: 'Personal Care', 
    keywords: 'soap bathing sabun handwash beauty body wash' 
  },
  { 
    code: '3402', 
    label: 'Detergent Powder, Washing Bars, Liquid Detergent & Dishwash', 
    category: 'Household', 
    keywords: 'detergent surf washing powder bar vim dishwash liquid tide surf excel ariel' 
  },
  { 
    code: '3306', 
    label: 'Toothpaste, Toothbrush & Oral Hygiene', 
    category: 'Personal Care', 
    keywords: 'toothpaste brush toothbrush colgate dantarjan oral rinse mouthwash' 
  },
  { 
    code: '3305', 
    label: 'Hair Oils, Shampoos & Hair Conditioners', 
    category: 'Personal Care', 
    keywords: 'hair oil shampoo conditioner parachute clinic plus sunsilk vatika' 
  },

  // ==========================================
  // 👕 GENERAL RETAIL, PHARMA & PACKAGING
  // ==========================================
  { 
    code: '3004', 
    label: 'Medicines, Pharmaceuticals & Tablets', 
    category: 'Healthcare', 
    keywords: 'medicine tablet capsule syrup pharma drug healthcare' 
  },
  { 
    code: '3304', 
    label: 'Cosmetics, Creams, Lotions & Skincare', 
    category: 'Personal Care', 
    keywords: 'cosmetic cream lotion beauty face wash sunscreen makeup' 
  },
  { 
    code: '6109', 
    label: 'T-Shirts, Garments, Apparel & Readymade Clothing', 
    category: 'Apparel', 
    keywords: 't-shirt shirt clothing garment cloth dress jeans pants cotton' 
  },
  { 
    code: '6403', 
    label: 'Footwear (Shoes, Sandals, Slippers & Chappals)', 
    category: 'Footwear', 
    keywords: 'shoes footwear sandal slipper chappal sneaker boot leather' 
  },
  { 
    code: '9403', 
    label: 'Furniture (Wooden, Steel Tables, Chairs, Beds & Desks)', 
    category: 'Furniture', 
    keywords: 'furniture chair table bed almirah desk wooden steel wardrobe' 
  },
  { 
    code: '4202', 
    label: 'Bags, Backpacks, Luggage, Suitcases & Wallets', 
    category: 'Accessories', 
    keywords: 'bag backpack luggage suitcase wallet purse trolley school bag' 
  },
  { 
    code: '7113', 
    label: 'Jewelry, Gold, Silver & Precious Stones', 
    category: 'Jewelry', 
    keywords: 'jewelry gold silver diamond ring necklace chain precious' 
  },
  { 
    code: '4819', 
    label: 'Packaging Materials (Corrugated Boxes, Cartons & Paper Bags)', 
    category: 'Packaging', 
    keywords: 'packaging box carton corrugated container paper bag packing' 
  },
  { 
    code: '8708', 
    label: 'Automobile & Bike Spare Parts', 
    category: 'Automotive', 
    keywords: 'automobile spare parts bike car auto vehicle motor brake clutch' 
  },

  // ==========================================
  // 💼 SAC SERVICES
  // ==========================================
  { 
    code: '9983', 
    label: 'IT, Software & Consulting Services', 
    category: 'Services', 
    keywords: 'it software consulting development web app computer technology' 
  },
  { 
    code: '9988', 
    label: 'Manufacturing & Job Work Services', 
    category: 'Services', 
    keywords: 'manufacturing job work fabrication processing contract' 
  },
  { 
    code: '9971', 
    label: 'Financial & Banking Services', 
    category: 'Services', 
    keywords: 'financial banking loan finance insurance credit interest' 
  },
  { 
    code: '9982', 
    label: 'Legal, Accounting & Auditing Services', 
    category: 'Services', 
    keywords: 'legal accounting audit lawyer ca advocate compliance gst' 
  },
  { 
    code: '9984', 
    label: 'Telecommunication & Internet Services', 
    category: 'Services', 
    keywords: 'telecom internet broadband lease line phone mobile service' 
  },
  { 
    code: '9985', 
    label: 'Support, Staffing & Security Services', 
    category: 'Services', 
    keywords: 'support staffing manpower security housekeeping maintenance' 
  }
];

export default DEFAULT_COMMON_HSN_CODES;
